import { render } from "./BaseEmptyCard.vue?vue&type=template&id=2604c24b&ts=true"
import script from "./BaseEmptyCard.vue?vue&type=script&lang=ts"
export * from "./BaseEmptyCard.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__